import script from "./RegressionTrendTool.vue?vue&type=script&lang=js"
export * from "./RegressionTrendTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__